/*
 * Trips API — dispatches to the localStorage mock or the real HTTP backend
 * based on USE_MOCK_API (VITE_USE_MOCK_API). Signatures are identical, so React
 * Query hooks and UI never change.
 */
import { USE_MOCK_API } from './httpClient'
import * as mock from './trips.mock'
import * as http from './trips.http'

const impl = USE_MOCK_API ? mock : http

export const listTrips = impl.listTrips
export const getTrip = impl.getTrip
export const createTrip = impl.createTrip
export const updateTrip = impl.updateTrip
export const deleteTrip = impl.deleteTrip
export const duplicateTrip = impl.duplicateTrip
